export const navCategories = [
  {
    id: 'news',
    name: '资讯门户',
    icon: 'ri-newspaper-line',
    desc: '要闻、快讯与深度报道一站式聚合',
    count: 128,
    tone: 'primary',
  },
  {
    id: 'video',
    name: '影视娱乐',
    icon: 'ri-film-line',
    desc: '剧集、综艺与短视频入口合集',
    count: 96,
    tone: 'accent',
  },
  {
    id: 'study',
    name: '学习工具',
    icon: 'ri-book-open-line',
    desc: '课程、题库与效率学习站点',
    count: 74,
    tone: 'secondary',
  },
  {
    id: 'shop',
    name: '购物比价',
    icon: 'ri-shopping-bag-3-line',
    desc: '商城、优惠与比价渠道导航',
    count: 63,
    tone: 'primary',
  },
  {
    id: 'community',
    name: '社区论坛',
    icon: 'ri-chat-smile-2-line',
    desc: '兴趣圈子、问答与交流社区',
    count: 58,
    tone: 'accent',
  },
  {
    id: 'office',
    name: '效率办公',
    icon: 'ri-briefcase-4-line',
    desc: '文档、协作与云端办公入口',
    count: 47,
    tone: 'secondary',
  },
  {
    id: 'life',
    name: '生活服务',
    icon: 'ri-service-line',
    desc: '出行、政务与便民服务直达',
    count: 52,
    tone: 'primary',
  },
  {
    id: 'media',
    name: '影音图库',
    icon: 'ri-image-2-line',
    desc: '素材、音乐与设计资源站',
    count: 39,
    tone: 'accent',
  },
];

export const latestAddresses = [
  {
    id: 'primary',
    size: 'large',
    name: '官网首页主入口',
    host: '51dh-home.com',
    tag: '主线路',
    status: '检测正常',
    latency: '28ms',
    updated: '2 分钟前更新',
    desc: '当前最稳定的官网首页入口，一键直达无需中转，适合日常访问与收藏，是遇到打不开时优先尝试的地址。',
    features: ['HTTPS 加密', '免跳转直达', 'PC / 移动通用'],
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20illustration%20of%20a%20stable%20web%20portal%20gateway%2C%20warm%20amber%20and%20terracotta%20geometric%20arch%20shapes%20on%20cream%20paper%20background%2C%20minimal%20editorial%20magazine%20style%2C%20soft%20film%20grain%2C%20no%20text&width=1000&height=700&seq=nav-latest-primary&orientation=landscape',
  },
  {
    id: 'backup',
    size: 'small',
    name: '备用线路 B',
    host: '51dh-b.net',
    tag: '备用',
    status: '检测正常',
    latency: '41ms',
    updated: '12 分钟前更新',
    desc: '主线路拥堵时自动切换的备用入口。',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20illustration%20of%20a%20backup%20network%20route%2C%20muted%20olive%20and%20amber%20shapes%20on%20cream%20background%2C%20minimal%20editorial%20style%2C%20soft%20grain%2C%20no%20text&width=600&height=600&seq=nav-latest-backup&orientation=squarish',
  },
  {
    id: 'mobile',
    size: 'small',
    name: '移动端专线',
    host: 'm.51dh-home.com',
    tag: '手机',
    status: '检测正常',
    latency: '35ms',
    updated: '18 分钟前更新',
    desc: '为手机浏览器优化的轻量访问入口。',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20illustration%20of%20a%20mobile%20access%20line%2C%20terracotta%20arcs%20on%20cream%20background%2C%20minimal%20editorial%20style%2C%20soft%20grain%2C%20no%20text&width=600&height=600&seq=nav-latest-mobile&orientation=squarish',
  },
  {
    id: 'fast',
    size: 'small',
    name: '极速镜像线',
    host: 'fast.51dh-home.com',
    tag: '加速',
    status: '检测正常',
    latency: '22ms',
    updated: '25 分钟前更新',
    desc: '加载优先，适合网络环境一般的用户。',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20illustration%20of%20a%20fast%20connection%20signal%2C%20amber%20concentric%20circles%20on%20cream%20background%2C%20minimal%20editorial%20style%2C%20soft%20grain%2C%20no%20text&width=600&height=600&seq=nav-latest-fast&orientation=squarish',
  },
  {
    id: 'oversea',
    size: 'small',
    name: '海外访问线',
    host: 'go.51dh-home.com',
    tag: '海外',
    status: '检测正常',
    latency: '68ms',
    updated: '31 分钟前更新',
    desc: '面向海外网络环境的独立接入地址。',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20illustration%20of%20a%20global%20network%20link%2C%20olive%20and%20cream%20blocks%20with%20thin%20amber%20lines%2C%20minimal%20editorial%20style%2C%20soft%20grain%2C%20no%20text&width=600&height=600&seq=nav-latest-oversea&orientation=squarish',
  },
];

export const accessSteps = [
  {
    step: '01',
    title: '先确认是不是站点本身在维护',
    desc: '打开浏览器无痕模式再访问一次。如果无痕下能打开，多半是本地缓存或插件拦截，清理缓存即可恢复。',
    icon: 'ri-refresh-line',
  },
  {
    step: '02',
    title: '换一条线路再试',
    desc: '回到上方「最新可用地址」，依次尝试备用线路 B、移动端专线与极速镜像线，任意一条通即可继续访问。',
    icon: 'ri-route-line',
  },
  {
    step: '03',
    title: '调整网络与 DNS',
    desc: '切换 Wi-Fi 与移动数据，或将 DNS 改为公共解析服务后重试，多数「打不开」都能在这一步解决。',
    icon: 'ri-signal-tower-line',
  },
  {
    step: '04',
    title: '仍无结果就用反馈通道',
    desc: '在下方反馈区留言说明地区与运营商，我们会把确认可用的最新地址第一时间更新到本页。',
    icon: 'ri-customer-service-2-line',
  },
];

export const featuredSites = [
  {
    name: '聚合要闻台',
    domain: 'yaowen.51dh-home.com',
    tag: '资讯',
    desc: '把当日热点与深度解读排成一份可读的清单，适合通勤路上快速浏览。',
    icon: 'ri-earth-line',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20illustration%20of%20a%20news%20aggregation%20board%2C%20layered%20amber%20cards%20and%20terracotta%20accents%20on%20cream%20paper%20background%2C%20minimal%20editorial%20style%2C%20soft%20grain%2C%20no%20text&width=800&height=520&seq=nav-feature-news&orientation=landscape',
  },
  {
    name: '追剧导航',
    domain: 'ju.51dh-home.com',
    tag: '影视',
    desc: '剧集、综艺与纪录片入口一次排好，更新日历随时可查。',
    icon: 'ri-play-circle-line',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20illustration%20of%20a%20streaming%20media%20portal%2C%20terracotta%20and%20cream%20rounded%20shapes%20with%20amber%20glow%2C%20minimal%20editorial%20style%2C%20soft%20grain%2C%20no%20text&width=800&height=520&seq=nav-feature-video&orientation=landscape',
  },
  {
    name: '随身书桌',
    domain: 'study.51dh-home.com',
    tag: '学习',
    desc: '课程、题库与文献检索集合，给需要长时间专注的人一个干净入口。',
    icon: 'ri-graduation-cap-line',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20illustration%20of%20a%20study%20toolkit%2C%20muted%20olive%20and%20amber%20geometric%20shapes%20on%20cream%20background%2C%20minimal%20editorial%20style%2C%20soft%20grain%2C%20no%20text&width=800&height=520&seq=nav-feature-study&orientation=landscape',
  },
  {
    name: '比价小道',
    domain: 'price.51dh-home.com',
    tag: '购物',
    desc: '优惠券、历史价格与商城入口聚合，帮你在下单前多看两眼。',
    icon: 'ri-price-tag-3-line',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20illustration%20of%20a%20price%20comparison%20trail%2C%20amber%20price%20tags%20and%20terracotta%20dots%20on%20cream%20background%2C%20minimal%20editorial%20style%2C%20soft%20grain%2C%20no%20text&width=800&height=520&seq=nav-feature-shop&orientation=landscape',
  },
  {
    name: '同好茶馆',
    domain: 'bbs.51dh-home.com',
    tag: '社区',
    desc: '兴趣圈子、问答与闲聊板块入口，找到还在认真讨论的人。',
    icon: 'ri-chat-3-line',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20illustration%20of%20a%20community%20chat%20bubbles%20cluster%2C%20terracotta%20and%20cream%20bubbles%20with%20amber%20outline%2C%20minimal%20editorial%20style%2C%20soft%20grain%2C%20no%20text&width=800&height=520&seq=nav-feature-community&orientation=landscape',
  },
  {
    name: '云端工位',
    domain: 'work.51dh-home.com',
    tag: '办公',
    desc: '文档、协作与云盘入口汇合，换个环境也能接着干活。',
    icon: 'ri-cloud-line',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20illustration%20of%20a%20cloud%20workspace%2C%20amber%20and%20olive%20layered%20panels%20on%20cream%20background%2C%20minimal%20editorial%20style%2C%20soft%20grain%2C%20no%20text&width=800&height=520&seq=nav-feature-office&orientation=landscape',
  },
];

export const communityComments = [
  {
    id: 'c1',
    user: '路过的老张',
    location: '广东 · 电信',
    time: '8 分钟前',
    text: '主入口今天早上有点慢，换了极速镜像线秒开，回来记一笔。建议大家优先试那个带「加速」标签的。',
    likes: 46,
    replies: 12,
    resolved: true,
  },
  {
    id: 'c2',
    user: '夜航船',
    location: '北京 · 联通',
    time: '23 分钟前',
    text: '用无痕模式试了一下就好了，果然是插件拦的。这个排查顺序写得挺清楚，省得我瞎折腾。',
    likes: 31,
    replies: 5,
    resolved: true,
  },
  {
    id: 'c3',
    user: '小满',
    location: '浙江 · 移动',
    time: '41 分钟前',
    text: '移动端专线收藏在手机桌面了，通勤路上刷要闻很顺手，希望别换地址换太勤。',
    likes: 27,
    replies: 8,
    resolved: false,
  },
  {
    id: 'c4',
    user: '海边捡贝壳',
    location: '海外 · 新加坡',
    time: '1 小时前',
    text: '海外访问线对我来说最稳，延迟 68ms 完全能接受，比来回找旧地址省心多了。',
    likes: 19,
    replies: 3,
    resolved: true,
  },
];

export const faqList = [
  {
    q: '51网址导航打不开，一般是什么原因？',
    a: '常见原因有三类：本地缓存或浏览器插件拦截、当前网络对部分线路不友好、以及站点正在进行维护换线。建议按页面「打不开这样进」的四步顺序排查，通常换一条最新可用地址就能恢复。',
  },
  {
    q: '页面上的「最新可用地址」多久更新一次？',
    a: '我们会对每条线路做持续探测，正常情况下每隔几分钟刷新一次检测状态。若某条线路连续不可用，会被替换成新的接入地址，并更新最后可用时间。',
  },
  {
    q: '找不到旧入口了，还能进去吗？',
    a: '可以。旧入口往往因为换线暂时失效，本页保留的备用线路与移动端专线覆盖了大多数旧入口的场景，依次尝试即可，无需再去搜索引擎里反复翻找。',
  },
  {
    q: '手机和电脑用的是同一个地址吗？',
    a: '不完全是。移动端专线针对手机浏览器做了轻量优化，加载更快；电脑端建议使用官网首页主入口。两者都能到达同一套导航内容，只是访问体验略有差别。',
  },
  {
    q: '访问时提示被拦截怎么办？',
    a: '先更换线路或网络环境，再关闭可能产生拦截的浏览器插件后重试。如果提示仍存在，欢迎在下方反馈区留言，注明地区与运营商，便于我们定位并补充可用地址。',
  },
];

export const heroStats = [
  { label: '今日线路检测', value: '5 条全部通过' },
  { label: '平均响应', value: '28ms' },
  { label: '最近更新', value: '2 分钟前' },
];